<template>
  <div id="app">
    <div class="body_bg">
      <div class="container whitebg pd15">
        <el-row :gutter="25">
          <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="main-content">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <!-- <div class="title_all" style=" margin-bottom: 0;">
                    <div class="title_left">News</div>
                    <div class="title_more2"><a href="/EN">Home</a>>News</div>
                    <div class="clearfix"></div>
                  </div> -->
                <listContent></listContent>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl></DocumentsNewsBlockControl>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentsNewsBlockControl from '../components/DocumentsNewsBlockControl/DocumentsNewsBlockControl'
import listContent from '../components/listContent'
export default {
  inject: ['reload'],
  data() {
    return {
      keywords: '',
      activeName: 'first',
    }
  },
  components: {
    DocumentsNewsBlockControl,
    listContent,
  },
  mounted() {
    document.title = 'News'
    this.reload()
  },
  methods: {},
}
</script>

<style scoped></style>
